<template>
  <div id="icons" class="px-3 px-sm-0">
    <v-row
      class="voting-icons"
      v-for="(smile, index) in spot.raetsel.lsg"
      :key="index"
    >
      <v-col cols="12" md="6" class="voting-icons-p" :style="{'color': theme.textColor}">{{ smile }}</v-col>
      <v-col cols="12" md="6" class="text-no-wrap icons-container">
        <img v-on:click="setSelectedSmile(index, iconType.negative, smileIcons[index].negative)" class="smile-icon" :src="smileIcons[index].negative" />
        <img v-on:click="setSelectedSmile(index, iconType.neutral, smileIcons[index].neutral)" class="smile-icon"  :src="smileIcons[index].neutral" />
        <img v-on:click="setSelectedSmile(index, iconType.positive, smileIcons[index].positive)" class="smile-icon"  :src="smileIcons[index].positive" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {layoutMixin} from '@/utils/layout-mixin'
import {solutionMixin} from '@/utils/solution-mixin'

export default {
  mixins:[layoutMixin,solutionMixin],
  props: {
    spot: {},
  },
  data: () => ({
    smileSelected: [],
    smileObj: [],
    final: [],
    smileIcons:[],
    iconsSrc: {
      negative: "/img/icons/smiley_sad_null.svg",
      neutral: "/img/icons/smiley_neutral_null.svg",
      positive: "/img/icons/smiley_happy_null.svg",
      value: null
    },
    iconType:{
      negative: 'negative',
      neutral: 'neutral',
      positive: 'positive'
    },
    disableInteraction: false,
  }),
  created() {
    this.generateIconsSrc();
    this.setResponses();
   },
  methods: {
     /**
     * Check if user has already respond to this and autofill the inputs
     */
    setResponses(){
      if ( this.spot.tstatus == 3 || this.spot.tstatus == 4 ){
        this.disableInteraction = true;  
        let inputJson = this.spot.raetsel.user_input_json;
        if(typeof this.spot.raetsel.user_input_json !== 'object'){
          inputJson = JSON.parse(this.spot.raetsel.user_input_json)
        }   
        this.spot.raetsel.lsg.forEach((element, index)=>{
          if (inputJson[element]!==undefined){
            let type = "";
            let icon = "";
            if (inputJson[element]==-1){
              type = this.iconType.negative;
              icon = this.iconsSrc.negative;
            }else if(inputJson[element]==0){
              type = this.iconType.neutral;
              icon = this.iconsSrc.neutral;
            }else{
              type = this.iconType.positive;
              icon = this.iconsSrc.positive;
            }
            this.prepareSmileObject(index, type, icon);
          }
        })       
      }
    },
    generateIconsSrc(){
      this.spot.raetsel.lsg.forEach(() => {
         this.smileIcons.push(Object.assign({}, this.iconsSrc));
      });
    },
    prepareSmileObject(index, type, icon){      
      const splitIconName = icon.split('_');
      let extension = splitIconName[2];
      switch(type) { 
        case this.iconType.negative: { 
              if(typeof extension !== 'undefined'){
                this.smileIcons[index].negative = extension === 'null.svg' ? '/img/icons/smiley_sad.svg' : '/img/icons/smiley_sad_null.svg';

                this.smileIcons[index].value = -1;

                this.smileIcons[index].neutral =  '/img/icons/smiley_neutral_null.svg';
                this.smileIcons[index].positive = '/img/icons/smiley_happy_null.svg';
              }else{
                this.smileIcons[index].value = null;
              }
              break; 
        } 
        case this.iconType.neutral: { 
            if(typeof extension !== 'undefined'){
            this.smileIcons[index].neutral = extension === 'null.svg' ? '/img/icons/smiley_neutral.svg' : '/img/icons/smiley_neutral_null.svg';

            this.smileIcons[index].value = 0;

            this.smileIcons[index].negative = '/img/icons/smiley_sad_null.svg';

            this.smileIcons[index].positive = '/img/icons/smiley_happy_null.svg';
            }else{
              this.smileIcons[index].value = null;
            }
            break; 
        } 
        case this.iconType.positive: { 
              if(typeof extension !== 'undefined'){
              this.smileIcons[index].positive = extension === 'null.svg' ? '/img/icons/smiley_happy.svg' : '/img/icons/smiley_happy_null.svg';

                this.smileIcons[index].value = 1;

              this.smileIcons[index].neutral =  '/img/icons/smiley_neutral_null.svg';
              this.smileIcons[index].negative = '/img/icons/smiley_sad_null.svg';
              }else{
                this.smileIcons[index].value = null;
              }
            break; 
        } 
      } 
      const smileObj  = [];
      this.smileIcons.forEach((element,index) => {
        if(element.value !== null){
          smileObj.push(this.spot.raetsel.lsg[index]+'('+ element.value+')');
        }
      });

      return smileObj;
    },
    setSelectedSmile(index, type, icon) {
        if (this.disableInteraction) return;//early return
        let smileObj = this.prepareSmileObject(index,type,icon);
        let serverInput=this.getServerData(smileObj, null, this.spot);     
        if(smileObj.length === this.spot.raetsel.lsg.length){
          this.$emit('input',smileObj,serverInput);
        }
    },
  },
};
</script>

<style scoped lang="scss">
#icons {
  .voting-icons {
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
    .voting-icons-p {
      display: flex;
      align-items: center;
      color: #000;
    }
    .icons-container {
       .smile-icon {
        cursor: pointer;
        width: 50px;
        margin: 0 10px 0 10px;
      }
    }
  }
}
</style>
